module.exports = __webpack_public_path__ + "img/blank.c1e76e1c.svg";